import { Link } from 'react-router';
import { EmptyState, Icon } from '../../components/ui';
import { PageHeader } from './pageParts';

export function NotFoundPage() {
  return (
    <div className="page">
      <PageHeader />
      <main className="page__main page__main--center">
        <EmptyState
          icon="compass"
          title="Nothing at this position"
          body="The page you’re looking for doesn’t exist, or the link has moved. Your shoots are one tap away."
          action={
            <Link className="btn btn--primary btn--md" to="/missions">
              <Icon name="arrow-left" size={16} />
              <span className="btn__label">Back to shoots</span>
            </Link>
          }
        />
      </main>
    </div>
  );
}
